module.exports = __webpack_public_path__ + "img/y-44.9ff63859.png";